import React from "react";

import FileInput from "./components/FileInput";
import ImageUploadContainer from "./components/ImageUploadContainer";
import ProfileImage from "./components/ProfileImage";
import CustomAccountCircle from "./components/CustomAccountCircle";
import CustomAddCircle from "./components/CustomAddCircle";
import UploadBtnText from "./components/UploadBtnText";

const UploadImage = ({ image, onImageChange, text, name }) => (
  <ImageUploadContainer>
    {image && image.length ? (
      <ProfileImage src={image} />
    ) : (
      <CustomAccountCircle />
    )}
    <CustomAddCircle />
    <UploadBtnText>{text}</UploadBtnText>
    <FileInput onChange={onImageChange} name={name} />
  </ImageUploadContainer>
);

export default UploadImage;
